import React from 'react';
import PropTypes from 'prop-types';

import './ResourceContentCardGrid.scss';
import ResourceContentCard from '../../../Elements/ResourceContentCard/ResourceContentCard';

export default class ResourceContentCardGrid extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        resourceContent: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                contentUrl: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
                image: PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.string,
                }).isRequired,
                marketingTag: PropTypes.shape({
                    name: PropTypes.string,
                    url: PropTypes.string,
                }).isRequired,
            })
        ),
        cardAlignment: PropTypes.oneOf([
            'left-align',
            'center-align',
            'right-align',
        ]),
        onResourceClick: PropTypes.func,
    };

    static defaultProps = {
        cardAlignment: 'left-align',
        onResourceClick: () => {},
    };

    render() {
        return (
            <div
                className={`component-Employer-Layout-ResourceContentCardGrid ${this.props.cardAlignment}`}
            >
                {this.props.resourceContent.map(
                    (content, idx) =>
                        content && (
                            <ResourceContentCard
                                {...content}
                                key={content.title}
                                onClick={this.props.onResourceClick}
                            />
                        )
                )}
            </div>
        );
    }
}
